<template>
  <div>
  <div id="commitee">
    <b-card-group deck>
      <b-card class="border-0" v-for="item in items" :key="item.key">
        <img :src="item.image" :alt="item.alt" class="mb-3" style="max-width:20%" />
        <b-card-text>
          <h1 class="text-primary font-weight-bold mb-3">{{ item.title }}</h1>
          <p class="text-secondary text-justify  mb-3" style=" font-size: 18px ">{{ item.description }}</p>
          <p class="text-secondary text-justify  mb-3" style=" font-size: 18px ">{{ item.description2 }}</p>
        </b-card-text>
      </b-card>
    </b-card-group>
</div>
    <div id="objectives">
    <b-card-group deck>
      <b-card class="border-0">
    <img class="mb-3 adcom" :src="require('@/assets/img/AdvisoryCommiteeicon.png')" fluid alt="Advisory Commitee"  />
    <b-card-text>
    <h1 class="text-primary font-weight-bold">Secure Our Future Advisory Commitee</h1>
          <p class="text-secondary mb-3 text-justify " style=" align-content: center; font-size: 18px ">The purpose of the Secure Our Future Advisory Committee (Committee) is to review, monitor, and make recommendations to the Superintendent and School Board, and inform the public regarding the use of proceeds generated from the assessment of a 0.75 mill levy of ad valorem taxes (Referendum) approved by voters on November 6, 2018, for the purpose of improving compensation for high quality teachers and instructional personnel employed by the Board, and increasing school safety and security personnel for Board-operated schools. The Committee is formed to provide transparency and instill confidence in Miami-Dade County taxpayers that these funds will be used for the purpose stated in the Referendum. The renewal of the Referendum ballot language has been approved by the School Board of Miami-Dade County and the Miami-Dade County Board of County Commissioners. The Ballot question has been approved and will be placed on the General Election Ballot of November 8, 2022. School Board Policy will be modified to provide for representation for the Charter School community on the Secure Our Future Advisory Committee.
          </p></b-card-text>
</b-card>
</b-card-group>
</div>
    <div class="BGcont">
      <b-card-group>
      <b-card>
      <b-img :src="require('@/assets/img/SOF2019-2020annualreport.jpg')" fluid alt="2019-2020 Annual Report Icon"/><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/Secure%20Our%20Future/Reports/M242%20-%20Attachment%20-%20SOFAC%202019-2020%20REPORT.pdf">2019-2020 Annual Report</a>
      </b-card><b-card>
      <b-img :src="require('@/assets/img/SOF2020-2021annualreport.jpg')" fluid alt="2020-2021 Annual Report Icon" /><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/Secure%20Our%20Future/Reports/M242%20-%20Attachment%20-%20SOFAC%202020-2021%20REPORT.pdf">2020-2021 Annual Report</a>
      </b-card><b-card>
      <b-img :src="require('@/assets/img/SOF2021-2022annualreport.jpg')" fluid alt="2021-2022 Annual Report Icon"/><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/Secure%20Our%20Future/Reports/M242%20-%20Attachment%20-%20SOFAC%202021-2022%20REPORT.pdf">2021-2022 Annual Report</a>
      </b-card><b-card>
      <b-img :src="require('@/assets/img/SOF2022-2023annualreport.jpg')" fluid alt="2022-2023 Annual Report Icon" /><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/Secure%20Our%20Future/Reports/M242%20-%20Attachment%20-%20SOFAC%202022-2023%20REPORT.pdf">2022-2023 Annual Report</a>
      </b-card><b-card>
      <b-img  :src="require('@/assets/img/SchoolBoardItemA-2.png')" fluid alt="School Board Item A-2 Final as adopted icon"/><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/2022%20SECURE%20OUR%20FUTURE%20FILES/A-2%20Final%20as%20adopted.pdf">School Board Item A-2 Final as adopted</a>
      </b-card><b-card>
<b-img :src="require('@/assets/img/Resolution22-030.png')" fluid alt="Miami-Dade County Board of County Commissioners Resolution 22-030" /><br><a target="_Blank" href="https://api.dadeschools.net/WMSFiles/123/2022%20SECURE%20OUR%20FUTURE%20FILES/Resolution%2022-030%20Fully%20Executed.pdf">Miami-Dade County Board of County Commissioners Resolution 22-030</a>
</b-card></b-card-group>
</div>
</div>
</template>

<script>
export default {
  name: "Objectives",
  data: () => ({
    items: [
      {
        key: "item-1",
        image: require("@/assets/img/Teachersimg.png"),
        alt: "Teacher instructing graphic",
        title: "Teachers",
        description: "Continue to Secure Our Future with outstanding teachers and instructional staff by improving compensation.",
        description2: "Miami-Dade County Public Schools (M-DCPS) gives Miami-Dade residents reason to be proud with ever-rising student achievement and graduation rates. This remarkable performance that earned our school system 3 consecutive 'A' ratings is largely the result of the exemplary work of teachers. Attracting and retaining committed, talented people to the teaching profession requires that they see a promising financial future in the profession!"
      },
      {
        key: "item-2",
        image: require("@/assets/img/SchoolSafety.png"),
        alt: "Security officer with hand raised and lock graphic",
        title: "School Safety",
        description: "Continue to Secure Our Future with School Police Officers in place to reinforce numerous safety enhancements that have been implemented. We continue to be vigilant and provide safe schools for ALL Miami-Dade County Students.",
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.wgraph {
  max-width: 35rem;
}
.BGcont {
  width: 100%;
}
#core {
  display: block;
  position: relative;
  top: -100px;
  visibility: hidden;
  background: blue;
}
.corev {
  max-height: 70%;
  max-width: 70%;
  padding: 1vw;
  min-width: 5vw;
}
.adcom{
max-width:10%
}

@media screen and (max-width: 1000px) {
  .corev {
    min-width: 90vw;
    padding: 0vw;
  }}
  @media screen and (max-width: 570px) {
  .adcom{
max-width:20%
}
}
</style>